export default async ({ commit }) => {
  commit('SHOW_PDF_DOCUMENT', true)
}



// WEBPACK FOOTER //
// ./src/brain/event-documents/ShowPdfDocument.js